import { Provider } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export const APP_INITIALIZER_MAT_DIALOG_DEFAULT_OPTIONS_PROVIDER: Provider[] = [
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: {
      autoFocus: false,
      disableClose: true,
      backdropClass: 'bg-[#E3EBF0CC]',
    },
  },
];
